import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { MdVisibility } from "react-icons/md";
import { MdVisibilityOff } from "react-icons/md";

import _constantUtil from '../utils/Constant';
import Loader from '../components/partials/Loader';
import config from '../config/config';
import mobileBar from '../assets/images/232213.jpg'

const {
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    EMPTY_STRING: emptyString,
    SEND_OTP_END_POINT,
    ONE,
    ZERO
} = _constantUtil;

function ForgotPassword() {
    const [email, setEmail] = useState(emptyString);
    const [password, setPassword] = useState(emptyString);
    const [loading, setLoading] = useState(falseValue);
    const [otpSent, setOtpSent] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);

    const MAX_RESEND_TIME = 59;
    const MAX_OTP_LENGTH = 6;
    const navigate = useNavigate();
    const storedThemeMode = sessionStorage.getItem('themeMode'); 
    const [otp, setOtp] = useState([emptyString, emptyString, emptyString, emptyString, emptyString, emptyString]);

    const [resendTimer, setResendTimer] = useState(MAX_RESEND_TIME);
    const [resendDisabled, setResendDisabled] = useState(falseValue);

    //* navigate to email verification
    useEffect(() => {
        if (otpSent) {
            navigate('/verify-otp', { state: { email, password } });
        }
    }, [otpSent, navigate, email, password]);

    //* handle change
    const handleChange = (event, index) => {
        const value = event.target.value;
        const newOtp = [...otp];

        if (/[0-9]/.test(value) || value === emptyString) {
            newOtp[index] = value;
            setOtp(newOtp);

            //* move focus to next input if a number is entered
            if (value && index < MAX_OTP_LENGTH - ONE) {
                document.getElementById(`otp__digit_${index + ONE}`).focus();
            }
        }
    };

    //* handle backspace separately
    const handleKeyDown = (event, index) => {
        if (event.key === 'Backspace') {
            const newOtp = [...otp];

            //* If input is empty, move focus back and clear the previous one
            if (!otp[index] && index > ZERO) {
                newOtp[index - ONE] = emptyString;
                setOtp(newOtp);
                document.getElementById(`otp__digit_${index - ONE}`).focus();
            } else {
                newOtp[index] = emptyString;
                setOtp(newOtp);
            }
        }
    };

    //* handle paste
    const handlePaste = (event, index) => {
        event.preventDefault();
        const pasteData = event.clipboardData.getData('text');
        const newOtp = [...otp];
        const digits = pasteData.split('').filter(char => /[0-9]/.test(char));

        digits.forEach((digit, i) => {
            if (index + i < newOtp.length) {
                newOtp[index + i] = digit;
            }
        });

        setOtp(newOtp);
    };


    //* execute send otp api
    function executeSendOTPapi(event) {
        //* prevent default
        event.preventDefault();
        setLoading(trueValue);
        setDisableButton(trueValue)
        const data = { email, password };

        //* api url
        const apiUrl = config.appBaseUrl + SEND_OTP_END_POINT;

        //* send otp
        axios.post(apiUrl, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            const result = res.data;
            if (result.status) {
                toast.success(result.message);
                setTimeout(() => {
                    setOtpSent(trueValue);
                    setLoading(falseValue);
                    setDisableButton(falseValue);
                }, 1500);
            } else {
                toast.error(result.message);
                setLoading(falseValue);
                setDisableButton(falseValue);
            }
        }).catch(error => {
            toast.error(error.message);
            setLoading(falseValue);
            setDisableButton(falseValue);
        });
    }

    return (
        <>
            <>
                <div className="grid">
                    <div className="order__left centered d-flex align-items-center justify-content-center">
                        <div className="form">
                            <div className="logo">
                                <h3 className='text-center'>Hire a Vendor for professionals</h3>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <p className='text-center'>We’ve sent a verification code to your email. Please enter it to proceed.</p>
                            </div>
                            <div className='otp-container mb-3'>
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        id={`otp__digit_${index}`}
                                        type='text'
                                        className={`otp__digit mx-3 otp__digit_${index} ${storedThemeMode === 'dark' ? 'text-white' : 'text-dark'}`}
                                        maxLength='1'
                                        value={digit}
                                        autoComplete='off'
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onPaste={(e) => handlePaste(e, index)}
                                    />
                                ))}
                            </div>
                            <button type="submit" className="login__button" onClick={() => navigate('/new-password')}>
                                Verify
                            </button>
                            <div className="signup">
                                <label className="remember_me">Already have an account?</label>
                                <Link
                                    to="/login"
                                    className="forgot__password text-golden"
                                    style={{ textDecoration: "none" }}
                                >
                                    <strong>Login</strong>
                                </Link>
                            </div>
                        </div>
                    </div>
                    {/* order__left centered */}
                    <div className="order__right centered no__overflow d-none d-md-block">
                        <img
                            className="img"
                            src={mobileBar}
                            alt="picture"
                        />
                    </div>
                    {/* order__right centered no__overflow */}
                </div>
                {/* end grid */}
            </>

        </>
    );
}

export default ForgotPassword;